import type { NativeToolbarButtonProps } from './types';

export const NativeToolbarButton: React.FC<NativeToolbarButtonProps> = () => null;
